const getFeatures = state => state.featuresDisplay;
const getCategories = state => state.categories;
const getVersions = state => state.versions;
const getTags = state => state.tags;
const getTextHighlight = state => state.textHighlight;


export default {
  getFeatures,
  getVersions,
  getCategories,
  getTags,
  getTextHighlight,
};
